module.exports = __webpack_public_path__ + "img/ZAR.96fa3602.svg";